<template>
	<div class="address-view">
		<div class="edit">
			<div class="edit__label">Søg</div>
			<vue-google-autocomplete
				ref="places"
				:id="String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now()"
				classname="form-control"
				placeholder=""
				v-on:placechanged="addressSelect"
				:country="['dk', 'de', 'es']"
				:key="'abc' + Date.now()"
			/>
		</div>
		<string-view label="Adresse" v-model="entity.address" :optional="optional.includes('address')" />
		<form-line-layout>
			<string-view label="Postnummer" v-model="entity.zip" :optional="optional.includes('zip')" />
			<string-view label="By" :weight="2" v-model="entity.city" :optional="optional.includes('city')" />
		</form-line-layout>
		<string-view label="Land" v-model="entity.country" :optional="optional.includes('country')" />
		<div class="btn" v-for="(addr, i) in _suggestions" :key="i" @click="select(addr.addr)">{{ addr.label }}</div>
	</div>
</template>

<script>
	import VueGoogleAutocomplete from 'vue-google-autocomplete'
	import merge from '../functions/merge'

	export default {
		data() {
			return {
				suggestions: []
			};
		},
		components: {
			'VueGoogleAutocomplete': VueGoogleAutocomplete
		},
		props: {
			contact_id: {
				type: Number,
				default: null
			},
			optional: {
				type: Array,
				default() {
					return [];
				}
			},
			value: {
				type: Object,
				default() {
					return {
						address: '',
						zip: '',
						city: '',
						country: ''
					};
				}
			}
		},
		watch: {
			contact_id(n) {
				var self = this;

				if (n) {
					this.axios
					.get('/contacts/' + n + '/tasks/latest/')
					.then(function (r) {
						self.suggestions = r.data._items.reduce(function (acc, cur) {
							var r = [];

							if (cur.details.hasOwnProperty('address')) {
								r.push(cur.details.address);
							}

							if (cur.type == 'move') {
								for (var i = 0; i < cur.details.route.length; ++i) {
									r.push(cur.details.route[i].address);
								}
							}

							if (cur.type == 'survey') {
								r.push(cur.details.dest);
							}

							return acc.concat(r);
						}, []);



						//
					});
				} else {
					this.suggestions = [];
				}
			}
		},
		computed: {
			_suggestions() {
				var used = [];
				var r = [];
				var s;
				var str;

				for (var i = 0; i < this.suggestions.length && used.length < 5; ++i) {
					s = this.suggestions[i];

					if (!s.address || !s.zip || !s.city || !s.country) continue;

					str = s.address + ', ' + s.zip + ' ' + s.city + ', ' + s.country;

					if (used.indexOf(str) == -1 && str.length > 10) {
						used.push(str);
						r.push({
							label: str,
							addr: s
						});
					}
				}

				return r;
			},
			entity: {
				get() {
					return this.value;
				},
				set(v) {
					this.$emit('input', v);
				}
			}
		},
		methods: {
			removeDuplicates(originalArray, prop) {
				var newArray = [];
				var lookupObject  = {};

				for(var i in originalArray) {
					lookupObject[originalArray[i][prop]] = originalArray[i];
				}

				for(i in lookupObject) {
					newArray.push(lookupObject[i]);
				}
				return newArray;
			},
			select(addr) {
				this.entity = addr;
			},
			addressSelect(data) {
				var self = this;

				self.entity.address 	= data.route + (data.street_number ? ' ' + data.street_number : '');
					self.entity.zip 		= data.postal_code;
					self.entity.city		= data.locality;
					self.entity.country		= data.country;
			}
		},
		mounted() {
			var self = this;
			var n = self.contact_id;

			

			if (n) {
				this.axios
				.get('/contacts/' + n + '/tasks/latest/')
				.then(function (r) {
					self.suggestions = r.data._items.reduce(function (acc, cur) {
						var r = [];

						if (cur.details.hasOwnProperty('address')) {
							r.push(cur.details.address);
						}

						if (cur.type == 'move') {
							for (var i = 0; i < cur.details.route.length; ++i) {
								r.push(cur.details.route[i].address);
							}
						}

						if (cur.type == 'survey') {
							r.push(cur.details.dest);
						}

						return acc.concat(r);
					}, []);



					//
				});
			} else {
				this.suggestions = [];
			}
		}
	}
</script>

<style lang="scss" scoped>
	.address-view {
		& > .btn, & > .team > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}

		& > div {
			margin-bottom: 20px;
		}

		> .form-control {
			background-color: #202127;
			height: 30px;
			color: white;
			width: 100%;
			font-size: 14px;
		}
	}
</style>